<template lang="html">
  <div id="sidebar">
    <div class="col-md-3 side-bar-container" v-if="showSidebar">
      <div  v-show="user">
        <div class="hideSidebar">
          <div class="sidebar-logo">
            <router-link :to="{ name: 'user-home-page', params: { lang: lang }}">
              <img class="img-responsive" src="../assets/img/icons/white-logo.svg" alt="Logo">
            </router-link>
          </div>
          <div class="notifications">
            <div class="sidebar-btn">
              <router-link to="/user-notificarions">
                <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/round-notifications-24px.svg" alt="Notification Icon"></span>
                {{translation.userNotification.notificationTitle}}
              </router-link>
            </div>
          </div>
          <div class="pets">
            <div class="sidebar-btn" @click="showPetsMethod">
              <router-link to="/pets-home">
                <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/sodebar-paw.svg" alt="Paw Icon"></span>
                {{translation.pets.pets}}
                <span v-if="showPets"><img class="img-responsive" src="../assets/img/icons/arrow-down.svg" alt="Arrow Icon"></span>
                <span v-else><img class="img-responsive" src="../assets/img/icons/white-arrow-sidebar.svg" alt="Arrow Icon"></span>
              </router-link>
            </div>
            <div v-if='showPets'>
              <div>
                <router-link to="/pets-registration"><span class="icon-padding"><img class="img-responsive add-button" src="../assets/img/icons/add-pet.svg" alt="Paw Icon"></span>
                   {{translation.header.add}}
                 </router-link>
               </div>
              <div v-for="pet in pets">
                <p class="sidebar-btn pet-btn-sidebar">
                  <span class="thumb" v-if="pet.petThumb">
                    <img class="img-circle img-responsive" v-bind:src="pet.petThumb" :alt="translation.profile.altImage + pet.petName">
                  </span>
                  <span class="thumb" v-else>
                    <img class="img-circle img-responsive" src="../assets/img/icons/empty-image-no-border.svg" alt="Default Image">
                  </span>
                  <span>{{pet.petName}}</span>
                  <p class="pet-btn-link">
                    <router-link :key="pet.petId" :to="{name:'view-pet-profile', params:{ petId: pet.petId}}">
                      <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/pet-profile-icon.svg" alt="Pet Profile Icon"></span>
                      {{translation.pets.profile}}
                      <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/white-arrow-sidebar.svg" alt="Pet Profile Icon"></span>
                    </router-link>
                  </p>
                  <p class="pet-btn-link">
                    <router-link :key="pet.petId" :to="{name:'view-pet-reviews', params:{ petId: pet.petId}}">
                      <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/pet-reviews.svg" alt="Pet Profile Icon"></span>
                      {{translation.petReview.reviews}}
                      <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/white-arrow-sidebar.svg" alt="Pet Profile Icon"></span>
                    </router-link>
                  </p>
                </p>
              </div>
            </div>
          </div>
          <div class="vet">
            <div class="sidebar-btn" @click="showVetsMethod">
              <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/pluse-arrow.svg" alt="Pluse Icon"></span>
              {{translation.doctor.doctors}}
              <span v-if="showVets"><img class="img-responsive" src="../assets/img/icons/arrow-down.svg" alt="Arrow Icon"></span>
              <span v-else><img class="img-responsive" src="../assets/img/icons/white-arrow-sidebar.svg" alt="Arrow Icon"></span>
            </div>
            <div v-if='showVets'>
              <div class="sidebar-btn">
                <router-link to="/favorite-vet"><span class="icon-padding">
                  <img class="img-responsive" src="../assets/img/icons/round-favorite-24px.svg" alt="Favorite Icon">
                </span>
                   {{translation.button.favorite}}
                </router-link>
              </div>
              <div class="sidebar-btn">
                <router-link to="/searching-vet">
                  <span class="icon-padding">
                    <img class="img-responsive" src="../assets/img/icons/round-search-24px.svg" alt="Paw Icon">
                  </span>
                   {{translation.button.search}}
                </router-link>
              </div>
            </div>
            <div class="grey-paws">
              <img class="img-responsive" src="../assets/img/icons/grey-paws.svg" alt="Paws Icon">
            </div>
          </div>
        </div>
      </div>
      <div v-show="doctor">
        <div class="sidebar-logo">
          <router-link :to="{ name: 'doctor-home', params: { lang: lang }}">
            <img class="img-responsive" src="../assets/img/icons/white-logo.svg" alt="Logo">
          </router-link>
        </div>
        <div class="doctor-add">
          <div class="sidebar-btn">
            <router-link to="/add-patient">
              <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/patient-plus.svg" alt="Add Patient"></span>
              {{translation.doctor.addPatient}}
            </router-link>
          </div>
          <div class="sidebar-btn">
            <router-link to="/search-pet">
              <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/round-search-24px.svg" alt="Search Icon"></span>
              {{translation.button.search}}
            </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 side-bar-mobile-container text-center" v-if="showSidebar && user">
      <div class="row">
        <div class="col-sm-4 col-xs-4">
          <router-link to="/user-notificarions">
            <p class="icon-padding"><img class="img-responsive" src="../assets/img/icons/round-notifications-24px.svg" alt="Notification Icon"></p>
            <p>{{translation.userNotification.notificationTitle}}</p>
          </router-link>
        </div>
        <div class="col-sm-4 col-xs-4">
          <router-link to="/pets-home">
            <p class="icon-padding"><img class="img-responsive" src="../assets/img/icons/sodebar-paw.svg" alt="Paw Icon"></p>
            <p>{{translation.pets.pets}}</p>
          </router-link>
        </div>
        <div class="col-sm-4 col-xs-4">
          <router-link to="/favorite-vet">
            <p class="icon-padding">
              <img class="img-responsive" src="../assets/img/icons/round-favorite-24px.svg" alt="Favorite Icon">
              <p>{{translation.button.favorite}}</p>
            </p>
          </router-link>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-xs-12 side-bar-mobile-container text-center" v-if="showSidebar && doctor">
      <div class="row">
        <div class="col-sm-12 col-xs-12 text-center">
          <div class="row">
            <div class="sidebar-btn col-sm-4 col-xs-4">
              <router-link to="/add-patient">
                <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/patient-plus24px.svg" alt="Add Patient"></span>
                <p>{{translation.doctor.addPatient}}</p>
              </router-link>
            </div>
            <div class="sidebar-btn col-sm-4 col-xs-4">
              <router-link to="/search-pet">
                <span class="icon-padding"><img class="img-responsive" src="../assets/img/icons/round-search-24px.svg" alt="Search Icon"></span>
                {{translation.button.search}}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SideBar',
  data(){
    return {
      translation: message,
      pets:'',
      user: false,
      doctor: false,
      showPets: true,
      showSidebar: false,
      showVets: false,
      lang: window.lang
    }
  },
  watch:{
    $route (to, from){
      if (to.path == '/') {
        this.$bus.$emit('sideBar', true);
      }
    }
  },
  mounted(){
    if (localStorage.getItem('userLoggedIn') != undefined || localStorage.getItem('doctorLoggedIn') !=undefined) {
      if (localStorage.getItem('userLoggedIn') || localStorage.getItem('doctorLoggedIn')) {
        this.showSidebar = true;
      }
    }else {
      this.showSidebar = false;
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.getPets();
    this.$bus.$on('logged', () => {
      this.getPets();
    });
    if (localStorage.getItem('userLoggedIn') != undefined) {
      if (localStorage.getItem('userLoggedIn')) {
        this.doctor = false;
        this.user = true;
        this.showSidebar = true;
        if (this.$route.name == 'home') {
          self.$router.push({ name: 'user-home-page', params: { lang: window.lang } })
        }
      }
    }else if (localStorage.getItem('doctorLoggedIn') != undefined) {
        if(localStorage.getItem('doctorLoggedIn')){
          this.user = false;
          this.doctor = true;
          this.showSidebar = true;
          if (this.$route.name == 'home') {
            self.$router.push({ name: 'doctor-home', params: { lang: window.lang } })
          }
        }
    }
    this.$bus.$on('createPet', () => {
      this.getPets();
    });
    this.$bus.$on('changeThumb', ()=>{
      this.getPets();
    })
    if (localStorage.getItem('userLoggedIn') != undefined || localStorage.getItem('doctorLoggedIn') !=undefined) {
      if (localStorage.getItem('userLoggedIn') || localStorage.getItem('doctorLoggedIn')) {
        this.showSidebar = true;
      }
    }else {
      this.showSidebar = false;
    }
    this.$bus.$on('sideBar', () => {
      if (localStorage.getItem('userLoggedIn') != undefined || localStorage.getItem('doctorLoggedIn') !=undefined) {
        if (localStorage.getItem('userLoggedIn') || localStorage.getItem('doctorLoggedIn')) {
          this.showSidebar = true;
          if (localStorage.getItem('userLoggedIn')) {
            this.doctor = false;
            this.user = true;
          }else if(localStorage.getItem('doctorLoggedIn')){
            this.user = false;
            this.doctor = true;
          }
        }
      }else {
        this.showSidebar = false;
      }
    });
    console.log('#Sidebar');
  },
  methods:{
    getPets: function(){
      this.loader = true;
      var self = this;
      axios.get('get-pets')
      .then(function (response){
          self.loader = false;
          self.pets = response.data.result
      })
      .catch(err => console.error(err))
    },
    showPetsMethod: function(){
      if (this.showPets) {
        this.showPets = !this.showPets;
      }else {
        this.showPets = !this.showPets;
      }
    },
    showVetsMethod: function(){
      if (this.showVets) {
        this.showVets = !this.showVets;
      }else {
        this.showVets = !this.showVets;
      }
    }
  }
}
</script>

<style lang="css">
#sidebar .side-bar-container{
  background: linear-gradient(to bottom, #3057b0 0%, #4377c5 100%);
  background-repeat:no-repeat;
  background-size:100% inherit;
  background-position:center;
  position: fixed;
  width:inherit;
  max-width:inherit;
  max-height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  padding-left: 0;
  text-align: left;
  padding: 10px;
  overflow-y: auto;
}
#sidebar .sidebar-btn img {
  display: inline-block;
}
#sidebar .sidebar-btn{
  color: #fff;
  margin-bottom: 2em;
}
#sidebar .sidebar-btn .thumb img{
  width: 4em;
  height: 4em;
  display: inline-block;
  margin-right: .5em;
  border: 2px solid #fff;
}
.pets .add-button {
  width: 4em;
  height: 4em;
  display: inline-block;
  margin-bottom: 1em;
}
#sidebar .sidebar-btn:hover{
  cursor: pointer;
}
#sidebar .grey-paws{
  position: absolute;
  bottom: 0;
  z-index: -1;
}
#sidebar .sidebar-logo{
  margin-bottom: 3em;
}
#sidebar .icon-padding{
  padding-right: 15px;
}
#sidebar .side-bar-container a{
  color: #fff;
}
#sidebar .side-bar-container a:hover{
  text-decoration: none;
}
#sidebar .side-bar-mobile-container{
  display: none;
}
#sidebar .pet-btn-sidebar{
  margin-bottom: .5em;
}
#sidebar .side-bar-container .pet-btn-link{
  padding-left: 1em;
}
@media (max-width: 1200px) {
  #sidebar .side-bar-container{
    display: none;
  }
  #loged-home {
    width: 100%;
  }
  #sidebar{
    display: block;
    position: fixed;
    z-index: 9999;
  }
  #sidebar .side-bar-mobile-container{
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #3057b0;
    height: 8em;
    z-index: 9999;
    color: #fff;
    padding-top: 1em;
  }
  #sidebar .side-bar-mobile-container a{
    color: #fff;
  }

}
@media (max-width: 1024px) {

  #sidebar .side-bar-mobile-container img{
    width: 4em;
    display: inline-block;
  }
    #sidebar .icon-padding{
      padding: 0;
      margin: 0;
    }
}
@media (max-width: 600px) {

  #sidebar .side-bar-mobile-container{
    display: block;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #3057b0;
    height: 6em;
    z-index: 9999;
    color: #fff;
      padding-top: 1em;
  }
  #sidebar .side-bar-mobile-container img{
    width: 2em;
  }
  #sidebar .side-bar-mobile-container a{
    color: #fff;
  }
  #sidebar .side-bar-mobile-container .col-sm-4{
    display: inline-block;
    width: 33%;
    text-align: center
  }
  #sidebar .icon-padding{
    padding: 0;
    margin: 0;
  }
}
</style>
